import { useSelector } from 'Flux/index.js'
import type { State } from 'Flux/Slice/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import type { OrderIntermediatesStatus } from '../../../../Generated/OrderIntermediatesStatus.ts'

const selectIntermediatesStatus = (state: typeof State) => state[orderSlice.name].intermediatesStatus

export const useGetIntermediatesStatusSelector: () => OrderIntermediatesStatus | null = () => useSelector(selectIntermediatesStatus)
